import Cookies from "js-cookie";
import { isJsonString } from "./util";
import { User } from "src/entities/user.entity";

export const getLoggedInKey = () => Cookies.get("loggedIn");

export const setLoggedInKey = (loggedInKey: string) => Cookies.set("loggedIn", loggedInKey, { path: "/" });

export const removeLoggedInKey = () => Cookies.remove("loggedIn", { path: "/" });

export const getLoggedInRoleKey = () => Cookies.get("loggedInRole");

export const setLoggedInRoleKey = (loggedInRoleKey: string) => Cookies.set("loggedInRole", loggedInRoleKey, { path: "/" });

export const removeLoggedInRoleKey = () => Cookies.remove("loggedInRole");

type CookiesStorage = {
  "current-admin": User;
  "current-employee": { id: string };
};

const GLOBAL_NOTIFICATIONS_ENABLED_KEY = "globalNotificationsEnabled";
const USERS_REPORTS_ALERT_KEY = "usersReportsHasUnreadAlert";
const COACH_RECORDINGS_ALERT_KEY = "coachRecordingsHasUnreadAlert";
const APP_STORAGE_EVENT = "app-storage-change";
export function setCookieWithKey<K extends keyof CookiesStorage>(key: K, value: CookiesStorage[K]) {
  const stringValue = typeof value === "string" ? value : JSON.stringify(value);
  Cookies.set(key, stringValue, { path: "/" });
}
export function getCookieWithKey<K extends keyof CookiesStorage>(key: K): CookiesStorage[K] | { id: string } {
  const stringValue = Cookies.get(key)!;

  return isJsonString(stringValue) ? JSON.parse(stringValue) : { id: stringValue };
}

// export const getLoggedInKey = () => localStorage.getItem("loggedIn");

// export const setLoggedInKey = (loggedInKey: string) => localStorage.setItem("loggedIn", loggedInKey);

// export const removeLoggedInKey = () => localStorage.removeItem("loggedIn");
// browserStorage.util.js

export const getGlobalNotificationsEnabled = () => {
  if (typeof window === "undefined") return true;

  const storedValue = window.localStorage.getItem(GLOBAL_NOTIFICATIONS_ENABLED_KEY);
  if (storedValue === null) return true;

  return storedValue === "true";
};

export const setGlobalNotificationsEnabled = (enabled: boolean) => {
  if (typeof window === "undefined") return;

  window.localStorage.setItem(GLOBAL_NOTIFICATIONS_ENABLED_KEY, String(enabled));
};

const emitAppStorageChange = (key: string) => {
  if (typeof window === "undefined") return;

  window.dispatchEvent(new CustomEvent(APP_STORAGE_EVENT, { detail: { key } }));
};

export const getUsersReportsHasUnreadAlert = () => {
  if (typeof window === "undefined") return false;

  return window.localStorage.getItem(USERS_REPORTS_ALERT_KEY) === "true";
};

export const setUsersReportsHasUnreadAlert = (hasUnread: boolean) => {
  if (typeof window === "undefined") return;

  window.localStorage.setItem(USERS_REPORTS_ALERT_KEY, String(hasUnread));
  emitAppStorageChange(USERS_REPORTS_ALERT_KEY);
};

export const clearUsersReportsUnreadAlert = () => {
  if (typeof window === "undefined") return;

  window.localStorage.removeItem(USERS_REPORTS_ALERT_KEY);
  emitAppStorageChange(USERS_REPORTS_ALERT_KEY);
};

export const APP_STORAGE_CHANGE_EVENT = APP_STORAGE_EVENT;

export const getCoachRecordingsHasUnreadAlert = () => {
  if (typeof window === "undefined") return false;

  return window.localStorage.getItem(COACH_RECORDINGS_ALERT_KEY) === "true";
};

export const setCoachRecordingsHasUnreadAlert = (hasUnread: boolean) => {
  if (typeof window === "undefined") return;

  window.localStorage.setItem(COACH_RECORDINGS_ALERT_KEY, String(hasUnread));
  emitAppStorageChange(COACH_RECORDINGS_ALERT_KEY);
};

export const clearCoachRecordingsUnreadAlert = () => {
  if (typeof window === "undefined") return;

  window.localStorage.removeItem(COACH_RECORDINGS_ALERT_KEY);
  emitAppStorageChange(COACH_RECORDINGS_ALERT_KEY);
};
